import { colors } from '@material-ui/core';

const white = '#FFFFFF';
const black = '#000000';

export default {
  black,
  white,
  primary: {
    contrastText: white,
    dark: colors.teal[700],
    main: colors.teal[300],
    light: colors.teal[100]
  },
  secondary: {
    contrastText: white,
    dark: colors.pink[700],
    main: colors.pink[300],
    light: colors.pink[100]
  },
  third: {
    contrastText: white,
    dark: colors.blue[700],
    main: colors.blue[300],
    light: colors.blue[100]
  },
  fourth: {
    contrastText: white,
    dark: colors.amber[700],
    main: colors.amber[300],
    light: colors.amber[100]
  },
  success: {
    contrastText: white,
    dark: colors.lightGreen[700],
    main: colors.lightGreen[300],
    light: colors.lightGreen[100]
  },
  info: {
    contrastText: white,
    dark: colors.lightBlue[700],
    main: colors.lightBlue[300],
    light: colors.lightBlue[100]
  },
  cancel: {
    contrastText: white,
    dark: colors.grey[700],
    main: colors.grey[300],
    light: colors.grey[100]
  },
  warning: {
    contrastText: white,
    dark: colors.yellow[700],
    main: colors.yellow[300],
    light: colors.yellow[100]
  },
  error: {
    contrastText: white,
    dark: colors.pink[700],
    main: colors.pink[300],
    light: colors.pink[100]
  },
  text: {
    primary: colors.blueGrey[700],
    secondary: colors.blueGrey[300],
    link: colors.blue[300]
  },
  background: {
    default: '#eeeeee',
    paper: white
  },
  icon: colors.blueGrey[300],
  divider: colors.grey[200]
};
